export default __webpack_public_path__ + "static/media/BudgetCalculator.c3ef47ed.JPG";